<template>
  <div>
    <el-table v-loading="loading" :data="tableData" style="width: 100%" border>
      <el-table-column type="index" label="序号"> </el-table-column>
      <el-table-column prop="openId" label="openId"> </el-table-column>
      <el-table-column prop="appId" label="appId"> </el-table-column>
      <el-table-column prop="unionId" label="unionId"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { querySubscriberMaPageApi } from "@/api/subscriber";
export default {
  name: "subscriberMa",
  props: {
    subscriberId: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      loading: false
    };
  },
  watch: {
    subscriberId: {
      immediate: true,
      handler(val) {
        if (!val) {
          return;
        }
        this.subscriberId = val;
        this.loadPage(1);
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      querySubscriberMaPageApi(this.subscriberId, this.searchForm)
        .then(res => {
          if (res.data.status == 100) {
            this.tableData = res.data.results.list;
            this.searchForm.total = res.data.results.total;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.searchForm.pageNum = val;
      this.loadPage();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.loadPage();
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// subscriberMa.vue?80c94a82